import type { ReactElement } from 'react';

import Address from 'models/Address';
import OrderHistoryMenu from 'models/OrderHistoryMenu';

type Props = { item: OrderHistoryMenu };

function RecipientDetails({ item }: Props): ReactElement {
  const {
    donated,
    donation_charity: donationCharity,
    recipient_email: recipientEmail,
  } = item;

  const {
    fullName,
    firstLine,
    secondLine,
    lastLine,
    local_phone_number: localPhoneNumber,
  } = new Address(item.shipping_address);

  return (
    <>
      <div className="col-12 col-sm-4 col-lg-4">
        <span className="c-heading c-heading--brand-8">
          RECIPIENT
        </span>

        <div className="u-text u-text--md">
          {donated ? (
            <span>
              Donated to
              {donationCharity}
            </span>
          ) : (
            <span>
              {fullName}
              <br />
              {recipientEmail}
              {recipientEmail && <br />}
              {`Tel: ${localPhoneNumber}`}
            </span>
          )}
        </div>
      </div>

      {!donated && (
        <div className="col-12 col-sm-4 col-lg-4">
          <div>
            <span className="c-heading c-heading--brand-8">
              DELIVERY ADDRESS
            </span>
          </div>

          <div className="u-text u-text--md">
            {firstLine}
            <br />
            {secondLine}
            {secondLine && <br />}
            {lastLine}
            <br />
          </div>
        </div>
      )}
    </>
  );
}

export default RecipientDetails;
